export const checkVitrine = history => {
  return history?.location?.pathname.includes('vitrine');
};
